module.exports = __webpack_public_path__ + "dist/media/logo--cs.8a255640.svg";